var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import Model from './Model';
import ReportParameterInfoModel from "./ReportParameterInfoModel";
/**
 *
 */
var ReportModel = /** @class */ (function (_super) {
    __extends(ReportModel, _super);
    /**
     *
     * @param data
     */
    function ReportModel(data) {
        return _super.call(this, data) || this;
    }
    ReportModel.prototype.initialize = function (data) {
        this.parameterInfos = [];
        this.columns = [];
    };
    /**
     *
     * @param data
     */
    ReportModel.prototype.update = function (data) {
        var _this = this;
        if (!data)
            return;
        var keys = Object.keys(data);
        keys.map(function (key) {
            switch (key) {
                case 'parameterInfos':
                    _this[key] = data[key].map(function (data) {
                        return new ReportParameterInfoModel(data);
                    });
                    break;
                default:
                    _this[key] = data[key];
            }
        });
    };
    Object.defineProperty(ReportModel.prototype, "requiredParameters", {
        get: function () {
            return this.parameterInfos.filter(function (reportParameterInfoModel) {
                return null;
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        observable
    ], ReportModel.prototype, "id", void 0);
    __decorate([
        observable
    ], ReportModel.prototype, "title", void 0);
    __decorate([
        observable
    ], ReportModel.prototype, "description", void 0);
    __decorate([
        observable
    ], ReportModel.prototype, "category", void 0);
    __decorate([
        observable
    ], ReportModel.prototype, "feature", void 0);
    __decorate([
        observable
    ], ReportModel.prototype, "parameterInfos", void 0);
    __decorate([
        observable
    ], ReportModel.prototype, "withTotals", void 0);
    __decorate([
        observable
    ], ReportModel.prototype, "columns", void 0);
    return ReportModel;
}(Model));
export default ReportModel;
